import moment from "moment";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { getTransactionHistory } from "../../../api/TransactionHistory";
import { ITrHistory } from "../../../interfaces/ITrHistory";
import { selectNewProfileRole } from "../../../store/newProfile/selector";

interface Return {
  data: {
    loadingActive: boolean;
    listHistory: ITrHistory[];
    longestDate: number;
  };
  method: {
    onGetHistory(id: string): void;
  };
}

export default function useViewModel(): Return {
  const [loadingActive, setLoadingActive] = useState(true);
  const [listHistory, setListHistory] = useState<ITrHistory[]>([]);
  const [longestDate, setLongestDate] = useState(0);
  const profile = useSelector(selectNewProfileRole);

  const onGetHistory = useCallback(
    async (id: string) => {
      setLoadingActive(true);
      await getTransactionHistory(id, profile.roleId)
        .then((res) => {
          const data: ITrHistory[] = res.map((e) => ({
            dateIn: moment(e.dateIn),
            description: e.historyDesc,
          }));
          /* eslint-disable arrow-body-style */
          setLongestDate(
            data.reduce((longest, obj) => {
              return moment(obj.dateIn).format(`DD MMMM, YYYY`).length > longest
                ? moment(obj.dateIn).format(`DD MMMM, YYYY`).length
                : longest;
            }, 0)
          );
          setListHistory(data);
        })
        .then(() => {
          setLoadingActive(false);
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
          setLoadingActive(false);
        });
    },
    [getTransactionHistory]
  );

  return {
    data: {
      loadingActive,
      listHistory,
      longestDate,
    },
    method: {
      onGetHistory,
    },
  };
}
